import React, { useState } from 'react'
import { FaArrowRight } from "react-icons/fa";
import { FeedbackForm } from '../../api/Global';
const ParentsFeedback = () => {
	const [userInfo, setUserInfo] = useState({
		userName: '',
		email: '',
		mobileNo: '',
		sonDaughterYearOfStudy: '',
		sonDaughterBranch: '',
		sonDaughterName: '',
	});
	const [ratings, setRatings] = useState({
		par1: 0,
		par2: 0,
		par3: 0,
		par4: 0,
		par5: 0,
		par6: 0,
		par7: 0,
		par8: 0,
		par9: 0,
		par10: 0,
	});

	const questions = [
		{ id: 'par1', text: 'Rate the program that your ward is undergoing in terms of the workload of the courses in different semesters' },
		{ id: 'par2', text: 'Rate the quality and relevance of course included in the semester' },
		{ id: 'par3', text: 'Rate the depth of curriculum of course studied by ward' },
		{ id: 'par4', text: 'Rate the availability of qualified and competent faculty in the college with respect to designed curriculum' },
		{ id: 'par5', text: 'Rate the availability of study material of the course' },
		{ id: 'par6', text: 'Rate the curricular and extra-curricular activities carried out for overall development of ward' },
		{ id: 'par7', text: 'Rate the relevance of curricular and extra-curricular activities carried out with respect to designed curriculum' },
		{ id: 'par8', text: 'Rate the relevance of the courses with respect to latest technological trends' },
		{ id: 'par9', text: 'Rate the usefulness of curriculum with respect to job perspective in Industry' },
		{ id: 'par10', text: 'Rate the transformation of your ward after completion of the courses' }
	];

	// Handle personal info change
	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setUserInfo({
			...userInfo,
			[name]: value
		});
	};

	// Handle radio button change for ratings
	const handleRatingChange = (parameter, value) => {
		setRatings({
			...ratings,
			[parameter]: value,
		});
	};

	// Handle form submission
	const handleSubmit = async (e) => {
		e.preventDefault();
		const atLeastOneRated = questions.some(question => ratings[question.id] !== undefined && ratings[question.id] !== 0);

		if (!atLeastOneRated) {
			alert("Please rate at least one question before submitting.");
			return;
		}
		const filteredRatings = questions
			.filter(question => ratings[question.id] !== undefined && ratings[question.id] !== 0)
			.map(question => ({
				parameter: question.text,
				rating: ratings[question.id]
			}));

		const payload = {
			formType: 'employer',
			...userInfo,
			ratings: filteredRatings
		};

		try {
			const response = await FeedbackForm(payload);
			console.log("response", response);
			if (response?.data?.status == true) {
				alert("Feedback created successfully")
				setUserInfo({
					userName: '',
					email: '',
					mobileNo: '',
					sonDaughterYearOfStudy: '',
					sonDaughterBranch: '',
					sonDaughterName: '',
				});

				setRatings({
					par1: 0,
					par2: 0,
					par3: 0,
					par4: 0,
					par5: 0,
					par6: 0,
					par7: 0,
					par8: 0,
					par9: 0,
					par10: 0,
				});
			}
		} catch (error) {
			console.log("error", error);
		}
	};
	return (
		<div>
			<div  className="overview-area aboutus-vi">
				<div  className="container">
					<div  className="bg-ligh">
						<form action="#" method="post" onSubmit={handleSubmit}  className="wpcf7-form init">
							<div  className="row">
								<div  className="col-md-12">
									<div  className="elementor-widget-container">
										<div  className="tm-modern-heading">

											<div  className="heading-primary-wrap">
												<h2  className="heading-primary elementor-heading-title">Feedback on
													Curriculum (Parents)
												</h2>
											</div>
											<div  className="heading-divider"></div>
											<div  className="heading-description-wrap">
												<div  className="heading-description">
												</div>
											</div>
										</div>
									</div>
								</div>
								<div  className="elementor-widget-container">
									<div  className="unicamp-contact-form-7">
										<div  className="row">
											<div  className="col-md-4 col-lg-4">
												<div  className="form-group">
													<label>User Name</label>
													<input  className="form-control border border-gray" placeholder="User Name" value={userInfo.userName} required
														type="text" name="userName" onChange={handleInputChange} />
												</div>
											</div>
											<div  className="col-md-4 col-lg-4">
												<div  className="form-group">
													<label>Email ID</label>
													<input  className="form-control border border-gray" placeholder="Email ID" value={userInfo.email} required
														type="email" name="email" onChange={handleInputChange} />
												</div>
											</div>
											<div  className="col-md-4 col-lg-4">
												<div  className="form-group">
													<label>Mobile No.</label>
													<input  className="form-control border border-gray" placeholder="Number" value={userInfo.mobileNo} required
														type="text" name="mobileNo" onChange={handleInputChange} />
												</div>
											</div>
											<div  className="col-md-4 col-lg-4">
												<div  className="form-group">
													<label>Son/Daughter Name </label>
													<input  className="form-control border border-gray"
														placeholder="Son/Daughter Name														" value=""
														value={userInfo.sonDaughterName} required
														type="text" name="sonDaughterName" onChange={handleInputChange} />
												</div>
											</div>

											<div  className="col-md-4 col-lg-4">
												<div  className="form-group">
													<label>Son/Daughter Branch</label>
													<select  className="form-control" required
														type="text" name="sonDaughterBranch" onChange={handleInputChange}>
														<option value="">-- Select --</option>														
														<option value="B.TECH">B.TECH</option>
														<option value="BBA">BBA</option>
														<option value="BCA">BCA</option>
														<option value="B.COM">B.COM</option>
														<option value="MBA">MBA</option>

													</select>
												</div>
											</div>
											<div  className="col-md-4 col-lg-4">
												<div  className="form-group">
													<label>Son/Daughter Year of Study</label>
													<select  className="form-control" required
														type="text" name="sonDaughterYearOfStudy" onChange={handleInputChange}>
														<option value="">-- Select --</option>
														<option value="2020">2020</option>
														<option value="2021">2021</option>
														<option value="2022">2022</option>
														<option value="2023">2023</option>
														<option value="2024">2024</option>
														<option value="2024">2025</option>

													</select>
												</div>
											</div>
											<div  className="col-md-12">
												<div  className="form-group  table-responsive">
													<table  className="table table-hover sportstbl">
														<thead>
															<tr>

																<th>
																	<p>Parameter</p>
																</th>
																<th>
																	<p>5(High)</p>
																</th>
																<th>
																	<p>4</p>
																</th>
																<th>
																	<p>3</p>
																</th>
																<th>
																	<p>2</p>
																</th>
																<th>
																	<p>1(Low)</p>
																</th>
															</tr>
														</thead>
														<tbody>
															{questions?.map((question) => (
																<tr key={question.id}>
																	<td>
																		<p>{question.text}</p>
																	</td>
																	{[5, 4, 3, 2, 1].map((ratingValue) => (
																		<td key={ratingValue}>
																			<input
																				type="radio"
																				name={question.id}
																				value={ratingValue}
																				checked={ratings[question.id] === ratingValue}
																				onChange={() => handleRatingChange(question.id, ratingValue)}
																			/>
																			{ratingValue}
																		</td>
																	))}
																</tr>
															))}
														</tbody>
													</table>
												</div>
											</div>
											<div  className="col-md-12 text-end">
												<div  className="form-groups">
													<div  className="form-submitss">
														<button  className="100%" type="submit">
															Submit
															<span  className="button-icon"><FaArrowRight />
															</span>
														</button>

													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

							</div>
						</form>

					</div>
				</div>
			</div>
		</div>
	)
}

export default ParentsFeedback